import axios from 'axios';
import settings from '../settings.js';
import React from 'react';

// API CALLS

const headers = { Authorization: `Bearer ${settings.ACCESS_TOKEN}` };

// Makes a call to specified airtable table. Uses information from settings.js JSON file
export function getTable(table, options) {
  return axios
    .get(
      `${settings.API_URL}${settings.AIRTABLE_ID}/${table}?offset=${options}`,
      { headers }
    )
    .then((response) => {
      return response;
    });
}

// Pass in array of tables and return array of url requests
export function getTableUrls(tables) {
  return tables.map((table) => {
    return axios.get(`${settings.API_URL}${settings.AIRTABLE_ID}/${table}`, {
      headers,
    });
  });
}
// api.getTables()  - Make multiple table requests. tables = array of tables
export const api = {
  getTables: (tables) => {
    return axios.all(getTableUrls(tables)).then((resultArr) => {
      return resultArr;
    });
  },
};

// String builder

// Builds URL querystring to be used in getLinkedTable function
function buildURLstring(recordArr) {
  return recordArr
    .map((record) => {
      return `RECORD_ID()='${record}',`;
    })
    .join('')
    .slice(0, -1);
}
// Will return data from linked table - pass in table and array of ID's you want to return against
export function getLinkedTable(table, recordArr) {
  const filterForumularstr = buildURLstring(recordArr);

  return axios.get(
    `${settings.API_URL}${settings.AIRTABLE_ID}/${table}?filterByFormula=OR(${filterForumularstr})`,
    { headers }
  );
}

/** GetTableWithFormular - Function to get a table details with formular as a parameter to filter the results
 * table (String) - Table name to query the results from
 * filterFormularStr (String) - The Formular string passed as a string to filterByFormula query parameter
 *
 * returns array of results
 * */
export function getTableWithFormular(table, filterForumularstr) {
  return axios.get(
    `${settings.API_URL}${settings.AIRTABLE_ID}/${table}?filterByFormula=OR(${filterForumularstr})`,
    { headers }
  );
}

// Populate dropdown lists - Pull in list array and field you want to return
// filter removes empty values
export function populateDropDown(list, field) {
  return list
    .sort((a, b) => (a.fields[field] > b.fields[field] ? 1 : -1))
    .filter(Boolean)
    .map((listitem) => (
      <option key={listitem.id} id={listitem.id} value={listitem.id}>
        {listitem.fields[field]}
      </option>
    ));
}
// Flatten an array
export function flatten(arr) {
  return [].concat(...arr);
}

//Return unique array and remove empty values
export function uniqueArray(array) {
  let result = Array.from(new Set(array)).filter(Boolean);
  return result;
}
